// extracted by mini-css-extract-plugin
export default {"wrapper":"InputBox_wrapper__PkpPY","leftIcon":"InputBox_leftIcon__1EcoG","withLeftIcon":"InputBox_withLeftIcon__h92xw"};